//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'login',
  data () {
    return {
      info:{},
      password:'',
      password1:'',
      password2:'',
    }
  },
  created(){
    this.account();
  },
  methods:{
    account(){
      this.$api.account({}).then((res)=>{
        if(res){
         this.info = res.data;
        }
      })
    },
    submit(){
        let that = this;
        if (!that.info.account) {
            that.$func.showToast('账号不存在');
            return false;
        }
        if (!this.password) {
            that.$func.showToast('请输入原密码');
            return false;
        }
        if (that.info.password != this.password) {
            that.$func.showToast('原密码不正确');
            return false;
        }
        if (!this.password1) {
            that.$func.showToast('请输入新密码');
            return false;
        }
        if (this.password1 != this.password2) {
            that.$func.showToast('两次输入密码不一致');
            return false;
        }
        this.$func.confirm('确认修改？','提示',()=>{
          that.$api.password({password:that.password,password1:that.password1,password2:that.password2}).then((res)=>{
            if(res){
              that.$func.alert('您的新密码为 "'+that.password1+ '" 请以后使用新密码登录','操作成功');
              that.account();
              that.password = '';
              that.password1 = '';
              that.password2 = '';
            }
          });
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/password.vue